import { createSlice } from '@reduxjs/toolkit'
import { _T } from 'utils/hooks/useTranslation'
import * as Yup from 'yup'

import { initYup } from "utils/helpers";
initYup();

export class CoolModeConfigItem {
  orientation?: string
  orientation_i18n?: string | undefined

  mitoyen?: string
  mitoyen_i18n?: string

  length?: string
  surface?: string

  occultant?: string
  occultant_i18n?: string
}

export interface CoolModeData {
  nbPeoples?: number
  inertia?: string
  inertia_i18nCode?: string
  location?: string
  location_i18nCode?: string
  temperature?: number
  econome?: number
  econome_i18nCode?: string
  config: CoolModeConfigItem[]
}

export const coolModeSchema = Yup.object().shape({
  nbPeoples: Yup.number().required(),
  inertia: Yup.string().required(),
  location: Yup.string(),
  temperature: Yup.number().required(),
  econome: Yup.number().required(),
  config: Yup.array().of(
    Yup.object().shape({
      orientation: Yup.string(),
      orientation_i18n: Yup.string(),
      mitoyen: Yup.string().required(),
      mitoyen_i18n: Yup.string(),
      length: Yup.string().required(),
      surface: Yup.string().required(),
      occultant: Yup.string().required(),
      occultant_i18n: Yup.string(),
    }),
  ),
})

export const defaultForm: CoolModeData = {
  nbPeoples: undefined,
  inertia: undefined,
  inertia_i18nCode: '',
  location: undefined,
  location_i18nCode: '',
  temperature: 24,
  econome: 1,
  econome_i18nCode: _T('ECONOME'),
  config: [
    {
      orientation: '1',
      orientation_i18n: _T('NORTH'),
      mitoyen: undefined,
      mitoyen_i18n: '',
      length: '',
      surface: '',
      occultant: undefined,
      occultant_i18n: '',
    },
    {
      orientation_i18n: _T('EST'),
      mitoyen: undefined,
      mitoyen_i18n: '',
      length: '',
      surface: '',
      occultant: undefined,
      occultant_i18n: '',
    },
    {
      orientation_i18n: _T('SOUTH'),
      mitoyen: undefined,
      mitoyen_i18n: '',
      length: '',
      surface: '',
      occultant: undefined,
      occultant_i18n: '',
    },
    {
      orientation_i18n: _T('WEST'),
      mitoyen: undefined,
      mitoyen_i18n: '',
      length: '',
      surface: '',
      occultant: undefined,
      occultant_i18n: '',
    },
    {
      orientation_i18n: _T('ROOF'),
      mitoyen: '0',
      mitoyen_i18n: 'NO',
      length: '0',
      surface: '0',
      occultant: '0',
      occultant_i18n: 'NO',
    },
  ],
}

const initialState = {
  form: { ...defaultForm },
}

export const cooleModeSlice = createSlice({
  name: 'cooleMode',
  initialState,
  reducers: {
    initNewProject(state) {
      state.form = { ...defaultForm }
    },
  },
})

export const { initNewProject } = cooleModeSlice.actions

export default cooleModeSlice.reducer
